import React,{useState,useEffect} from 'react';
import { Dialog,DialogTitle,DialogContent,DialogActions,TextField,Button,Stack } from '@mui/material';
import apiService from '../services/apiService.ts';

interface Props{
  open:boolean;
  onClose:()=>void;
  locationId:string;
  initial?:any;
  onSaved:()=>void;
}

const SpaceDialog:React.FC<Props>=({open,onClose,locationId,initial,onSaved})=>{
 const [name,setName]=useState('');
 const [capacity,setCapacity]=useState(0);

 useEffect(()=>{
  if(initial){setName(initial.name||'');setCapacity(initial.capacity||0);}else{setName('');setCapacity(0);}
 },[initial]);

 const handleSave=async()=>{
  const payload={name,capacity};
  if(initial?.id) await apiService.updateSpace(locationId,initial.id,payload);
  else await apiService.createSpace(locationId,payload);
  onSaved();
  onClose();
 };

 return(
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>{initial?'Edit Space':'New Space'}</DialogTitle>
    <DialogContent>
      <Stack spacing={2} mt={1}>
        <TextField label="Name" value={name} onChange={e=>setName(e.target.value)} fullWidth/>
        <TextField label="Capacity" type="number" value={capacity} onChange={e=>setCapacity(Number(e.target.value))} fullWidth/>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button variant="contained" onClick={handleSave}>Save</Button>
    </DialogActions>
  </Dialog>
 );
};
export default SpaceDialog;